/**
 * The `anonId` query parameter.
 *
 * A user can arrive carrying an `anonId` on the URL that represents their
 * anonymous identity on the originating surface. We use it to
 * instantiate the Statsig client with that id so feature-gate and experiment
 * bucketing line up across surfaces.
 */
export const ANON_ID_QUERY_PARAM = 'anonId';

/**
 * Reads and trims the `anonId` query parameter from a URL search string.
 *
 *
 * @param search - A URL query string (e.g. `window.location.search`). A leading
 * `?` is optional.
 * @returns The trimmed `anonId` value, or `null` when it is absent, empty, or
 * cannot be parsed.
 */
export const getAnonIdFromQuery = (search: unknown): string | null => {
  if (typeof search !== 'string' || search.length === 0) {
    return null;
  }

  try {
    const value = new URLSearchParams(search).get(ANON_ID_QUERY_PARAM);
    const trimmed = value?.trim();
    return trimmed ? trimmed : null;
  } catch {
    // `URLSearchParams` is very tolerant, but never let a
    // parsing failure break initialisation for every user.
    return null;
  }
};
